import { useEffect } from "react";

import * as editorActions from "@/lib/state/actions/editor-actions";
import { useAppDispatch } from "@/lib/state/store";

import { useSave } from "./use-save";

export const useKeyboardShortcuts = () => {
  const dispatch = useAppDispatch();
  const { saveAnimation } = useSave();

  useEffect(() => {
    const keyListener = (event: KeyboardEvent) => {
      if (event.code === "ArrowRight") {
        return dispatch(editorActions.nextFrame());
      }
      if (event.code === "ArrowLeft") {
        return dispatch(editorActions.previousFrame());
      }
      if ((event.ctrlKey || event.metaKey) && event.key === "z") {
        return dispatch(editorActions.undo());
      }
      if ((event.ctrlKey || event.metaKey) && event.key === "y") {
        event.preventDefault();
        return dispatch(editorActions.redo());
      }
      if ((event.ctrlKey || event.metaKey) && event.key === "s") {
        event.preventDefault();
        return saveAnimation();
      }
    };

    document.addEventListener("keydown", keyListener);

    return function cleanup() {
      document.removeEventListener("keydown", keyListener);
    };
  });
};
